import { Container, Grid } from "@material-ui/core";
import { Box } from "@mui/material";
import React from "react";
import { ChatGptForm } from "./ChatGptForm";
import { LabelWithBackLine } from "../../../../../../components/LabelWithBackLine";

export const ChatGptParams = () => {
  return (
    <>
      <Container
        style={{
          boxShadow: "none",
          padding: 0,
        }}
        maxWidth="xl"
      >
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            style={{
              boxShadow: "none",
              width: "100%",
            }}
          >
            <LabelWithBackLine>Resumo de Publicações</LabelWithBackLine>
            <Box
              display="flex"
              alignItems="center"
              style={{
                padding: 0,
                marginTop: "35px",
                width: "100%",
                marginBottom: "35px",
              }}
              boxShadow="none"
            >
              <ChatGptForm />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};
